import Vue from 'vue';
import * as types from './types';

const mutations = {
  [types.RESET_STATE](state) {
    // Object.assign(state, initialState);
  },
  [types.FETCH_AGREEMENT_PENDING](state) {
    state.fetchAgreementPending = true;
  },
  [types.FETCH_AGREEMENT_FULFILLED](state, agreement) {
    Vue.set(state, 'agreement', agreement.data.data);
    state.fetchAgreementPending = false;
  },
  [types.FETCH_AGREEMENT_ERROR](state) {
    state.fetchAgreementPending = false;
  },
};

export default mutations;
